export default __webpack_public_path__ + "static/media/maps.ebfb5e38.png";